<div>
  @if (invoiceId && tenantId) {
    <app-receipt
      [invoiceId]="invoiceId"
      [tenantId]="tenantId"
      [isAPI]="true"
    ></app-receipt>
  } @else {
    <div class="text-error">
      <p>Unable to load invoice. URL is invalid.</p>
    </div>
  }
</div>